import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.197 15.482c-1.415.842-5.124 2.562-2.865 4.715C5.435 21.248 6.665 22 8.21 22h8.818c1.546 0 2.775-.752 3.879-1.803 2.259-2.153-1.45-3.873-2.865-4.715a10.66 10.66 0 0 0-10.845 0"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-width": "1.5",
      d: "M17.12 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
    }, null, -1)
  ])))
}
export default { render: render }